import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SessionStorageService } from "../storage/session-storage.service";
import { SessionStorageEnum } from "../storage/session-storage-constants";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { map } from "rxjs/operators";
import { ApiChecklistConstants } from "../../constants/api-constants/api-checklist.constants";
import { HttpClient } from "@angular/common/http";
import { ApiCommunicationConstants } from "../../constants/api-constants/api-communication.constants";
import { ApiAttachmentConstants } from "../../constants/api-constants/api-attachment.constants";
import { ApiResultConstants } from "../../constants/api-constants/api-result.constants";
import { ApiConditionConstants } from "../../constants/api-constants/api-condition.constants";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ApiInvoiceConstants } from "../../constants/api-constants/api-invoice.constants";
import { ApiCommentsConstants } from "../../constants/api-constants/api-comments.constants";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { AppControllerService } from "../../../app-controller.service";
let SelectedApplicationService = class SelectedApplicationService {
    sessionStorageService;
    applicationSearchService;
    appControllerService;
    http;
    selectedApplicationSubject = new BehaviorSubject(null);
    $selectedApplication = this.selectedApplicationSubject.asObservable();
    selectedDraftApplicationSubject = new BehaviorSubject(null);
    $selectedDraftApplication = this.selectedDraftApplicationSubject.asObservable();
    getSingleApplicationSubscription;
    constructor(sessionStorageService, applicationSearchService, appControllerService, http) {
        this.sessionStorageService = sessionStorageService;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.http = http;
    }
    setSelectedApplication(application) {
        this.selectedApplicationSubject.next(application);
        if (!application) {
            return;
        }
        this.appControllerService.selectedJobID = application.jobId;
        this.sessionStorageService.set(SessionStorageEnum.SelectedJobID, application.jobId.toString());
    }
    setSelectedDraftApplication(draftApplication) {
        this.selectedDraftApplicationSubject.next(draftApplication);
    }
    removeSelectedDraftApplication() {
        this.selectedDraftApplicationSubject.next(null);
    }
    removeSelectedApplication() {
        this.appControllerService.selectedJobID = null;
        this.sessionStorageService.remove(SessionStorageEnum.SelectedJobID);
        this.selectedApplicationSubject.next(null);
    }
    fetchSelectedApplicationFromJobID(jobID, aflaModuleStrategyService) {
        this.getSingleApplicationSubscription = this.applicationSearchService.getSingleApplication(aflaModuleStrategyService, jobID).subscribe((selectedApplication) => {
            this.setSelectedApplication(selectedApplication);
        });
    }
    getChecklistsObservable(params) {
        return this.http.get(ApiChecklistConstants.URL, { params });
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params });
    }
    getCommunicationsObservable(params) {
        return this.http.get(ApiCommunicationConstants.URL, { params }).pipe(map(response => {
            if (response && response.value) {
                response.value = response.value.map(communication => {
                    if (communication.description) {
                        communication.description = communication.description
                            .replace(/\\r\\n/g, "<br>")
                            .replace(/\\n/g, "<br>")
                            .replace(/\r\n/g, "<br>")
                            .replace(/\n/g, "<br>");
                    }
                    return communication;
                });
            }
            return response;
        }));
    }
    logCommunicationsObservable(communicationDto) {
        return this.http.post(ApiCommunicationConstants.URL, communicationDto);
    }
    getAttachmentsObservable(jobId, attachmentType) {
        let _filter = "";
        if (attachmentType && attachmentType.length > 0)
            _filter = `and attachmentType eq '${attachmentType}'`;
        const params = {
            $filter: `jobId eq ${jobId} ${_filter} and deleted eq false`
        };
        return this.http.get(ApiAttachmentConstants.URL, { params });
    }
    getResultsObservable(params) {
        return this.http.get(ApiResultConstants.URL, { params });
    }
    getConditionsObservable(params) {
        return this.http.get(ApiConditionConstants.URL, { params });
    }
    getInvoice(params) {
        return this.http.get(ApiInvoiceConstants.URL, { params }).pipe(map((data) => { return data.value; }));
    }
    getCommentsObservable(params) {
        return this.http.get(ApiCommentsConstants.URL, { params });
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${attachmentId}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: HttpClient }
    ];
};
SelectedApplicationService = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], SelectedApplicationService);
export { SelectedApplicationService };
